import React, { Fragment } from "react";

import useWindowDimensions from "../../../hooks/useWindowDimensions";

import { LayoutTypes } from "../../../types/layout";

import Button from "../../buttons/Button";
import LastNews from "./lastNews";
import Navbar from "./navbar";
import Sidebar from "./sidebar";

const Header = ({
  headerImage,
  title,
  additionalTitle,
  subtitle,
  height,
  buttons,
  news,
  withOverlay,
  withoutHero,
  homePage,
}: LayoutTypes) => {
  const { isSmallScreen } = useWindowDimensions();

  const gradientDefault =
    "linear-gradient(96.19deg, #0177a9 4.89%, #012e4b 54.96%)";
  const overlayGradient = withOverlay
    ? `linear-gradient(90deg, rgba(0, 49, 70, 0.7) 0%, rgba(0, 18, 30, 0.7) 100%),`
    : "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.49) 50%, rgba(0, 0, 0, 0.7) 100%),";

  const renderGradient = news ? gradientDefault : "";

  const backgroundImage = headerImage
    ? `${overlayGradient} url("${headerImage}")`
    : renderGradient;

  return (
    <header
      className={`m-header ${withOverlay || news ? "-withOverlay" : ""} ${
        withoutHero ? "-withoutHero" : ""
      }`}
      style={{
        backgroundImage: backgroundImage,
        height: news ? "100%" : height ?? "100vh",
      }}
    >
      {isSmallScreen ? <Sidebar /> : <Navbar homePage={homePage} />}

      {!withoutHero && (
        <Fragment>
          {news ? (
            <LastNews />
          ) : (
            <div
              className={`m-header__content ${
                withOverlay ? "-withOverlay" : ""
              }`}
            >
              <div className="_wr">
                <div className="_w">
                  <div className={`_12 ${!withOverlay ? "_m6" : ""}`}>
                    <div className="m-header__titleContainer fullWidth">
                      <div
                        className={`m-header__title ${
                          withOverlay ? "text-centered fullWidth" : ""
                        }`}
                      >
                        <p
                          className={`-title${
                            withOverlay ? "" : "__headerFirst"
                          } sectionTitle text-white`}
                        >
                          {title}
                        </p>

                        {additionalTitle && (
                          <p className="-title__headerSecond">
                            {additionalTitle}
                          </p>
                        )}
                        {subtitle && (
                          <p className="text-white -mt25 -mb25 m-header__subtitle">
                            {subtitle}
                          </p>
                        )}

                        {buttons && (
                          <div className="row -column-gap25">
                            {buttons.map(
                              ({ id, name, handleClick, buttonClass }) => (
                                <Button
                                  key={id}
                                  name={name}
                                  handleClick={handleClick}
                                  buttonClass={buttonClass}
                                />
                              )
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Fragment>
      )}
    </header>
  );
};

export default Header;
